<template>
  <div
    class="app-download"
    data-test="app-download">
    <div class="app-download-info">
      <h2 class="title">Download the free app</h2>
      <p
        class="desc">
        Luminary offers access to shows from top creators you won’t find anywhere else, plus the ones you already love.</p>
      <appstore-links/>
    </div>
    <div class="app-image">
      <img
        :src="srcSet('src', twoPhonesImgs)"
        :srcset="srcSet('srcset', twoPhonesImgs)">
    </div>
  </div>
</template>
<script>
import AppStoreLinks from './AppStoreLinks';
import twoPhones1x from '../assets/images/twoPhones_1x.png';
import twoPhones2x from '../assets/images/twoPhones_2x.png';
import twoPhones3x from '../assets/images/twoPhones_3x.png';

export default {
  name: 'AppDownload',
  components: {
    'appstore-links': AppStoreLinks,
  },
  data() {
    return {
      twoPhonesImgs: [twoPhones1x, twoPhones2x, twoPhones3x],
    };
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/variables.scss";
.app-download {
  background-color: $brand;
  display: flex;
  overflow: hidden;
  max-height: 310px;
  padding: 0 15%;
  .app-download-info {
    padding: 40px 15px;
    margin: 0 auto;
    .title {
      font-family: $clearface-bold;
      font-size: 40px;
      letter-spacing: -0.8px;
    }
    .desc {
      line-height: 22px;
      letter-spacing: -0.2px;
      color: $black;
      max-width: 511px;
      font-family: Favorit-light;
    }
    .appstore-images {
      margin: 34px 0 auto;
      img {
        &:first-child {
          margin-right: 16px;
        }
      }
    }
  }
  .app-image {
    margin: 0 auto;
    img {
      max-width: 350px;
      margin-top: 25px;
      height: 100%;
    }
  }
}
@media (max-width: $lg) {
  .app-download {
    padding: 0 10%;
  }
}
@media (max-width: $md) {
  .app-download {
    padding: 0 5%;
    .app-image {
      img {
        max-width: 300px;
        margin-top: 50px;
      }
    }
  }
}
@media (max-width: $sm) {
  .app-download {
    padding: 0 3%;
    flex-direction: column;
    max-height: 478px;
    .app-download-info {
      padding: 15px;
      text-align: center;
      .title {
        font-size: 32px;
      }
    }
    .app-image {
      img {
        margin-top: 30px;
      }
    }
  }
}
@media (max-width: $xxs) {
  .app-download {
    .app-download-info {
      padding: 15px 0 0 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/AppDownload.vue